// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DeviceKey, IDeviceKey } from "./DeviceKey.gen";
import { AllocatedDeviceKeyResult, IAllocatedDeviceKeyResult } from "./AllocatedDeviceKeyResult.gen";

export interface IDeviceKeySearchResult {
	pendingKeys: IDeviceKey[] | undefined;

	allocatedKeys: IAllocatedDeviceKeyResult[] | undefined;

	$type?: string | undefined;
}
export class DeviceKeySearchResult {
	constructor(data?: IDeviceKeySearchResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.pendingKeys = data.pendingKeys ? data.pendingKeys.map((p: any) => new DeviceKey(p)) : [];
		this.allocatedKeys = data.allocatedKeys ? data.allocatedKeys.map((a: any) => new AllocatedDeviceKeyResult(a)) : [];
	}

	pendingKeys: DeviceKey[] | undefined = [];

	allocatedKeys: AllocatedDeviceKeyResult[] | undefined = [];

	static $type: string = "CoreApi.Models.DeviceKeySearchResult, ";
	$type?: string | undefined = DeviceKeySearchResult.$type;
}

